import { useTranslations } from 'next-intl';

type Props = {
  onDiscard: () => void;
};

export const DiscardDraftBanner = ({ onDiscard }: Props) => {
  const t = useTranslations();

  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <div className={styles.indicator} />
        <div className={styles.message}>
          {t.rich('memoComposer.unpublished', {
            discard: (chunks) => (
              <button
                onClick={onDiscard}
                type="button"
                className={styles.discardButton}
              >
                {chunks}
              </button>
            ),
          })}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: 'flex mb-8',
  banner: 'bg-[#FFFCD8] items-center gap-2 px-2 rounded-xl inline-flex ml-auto',
  indicator: 'bg-[#F7CB2D] w-2 h-2 rounded-full',
  message: 'text-[#826514]',
  discardButton: 'underline text-red-600 cursor-pointer',
};
